import { AppConfig } from '../app-config'

const getWebsiteContactNumber = (locale = 'in') => {
	return AppConfig.contact_number[locale ? locale : 'in']
}

export default getWebsiteContactNumber
